import _ from 'lodash';

import { useMemo } from 'react';
import { useThirdPartyLogisticsActivityQuery } from 'generated/graphql';



export interface IStore {
  id: string;
  orderPrefix: string;
  name: string;
}

export interface IData {
  stores: IStore[];
}

export function useQuery() {
  const tuple = useThirdPartyLogisticsActivityQuery({
    variables: {
      storeTypes: ['customizableFormat']
    }
  });



  return useMemo(
    () => {
      const data: IData = {
        stores: _.map(tuple.data?.stores.nodes ?? [], (store): IStore => ({
          id: store.id,
          orderPrefix: store.orderPrefix,
          name: store.name
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
